import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-4 mb-8 container" },
    [
      _c("h2", [_vm._v("Instructions:")]),
      _vm._m(0),
      _c(VFileInput, {
        attrs: { label: "Select PDF" },
        on: { change: _vm.loadPDF },
      }),
      _vm.pdfDoc
        ? _c(
            "div",
            [
              _c("h3", [_vm._v("Form Fields:")]),
              _c(
                VChipGroup,
                { attrs: { column: "" } },
                _vm._l(_vm.formFields, function (field) {
                  return _c(VChip, { key: field.name }, [
                    _vm._v(
                      " " +
                        _vm._s(field.name) +
                        " (" +
                        _vm._s(field.type) +
                        ") "
                    ),
                  ])
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(VDivider, { staticClass: "my-4" }),
      _vm.pdfDoc
        ? _c(VFileInput, {
            attrs: { label: "Select CSV" },
            on: { change: _vm.loadCSV },
          })
        : _vm._e(),
      _vm.csvRows.length
        ? _c(VSelect, {
            attrs: { items: _vm.fontOptions, label: "Font" },
            model: {
              value: _vm.font,
              callback: function ($$v) {
                _vm.font = $$v
              },
              expression: "font",
            },
          })
        : _vm._e(),
      _vm.csvRows.length
        ? _c(VSelect, {
            attrs: { items: _vm.fontSizes, label: "Font Size", clearable: "" },
            model: {
              value: _vm.fontSize,
              callback: function ($$v) {
                _vm.fontSize = $$v
              },
              expression: "fontSize",
            },
          })
        : _vm._e(),
      _vm.csvRows.length
        ? _c(VDataTable, {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.csvHeaders,
              items: _vm.csvRows,
              "items-per-page": 5,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.action`,
                  fn: function ({ item, index }) {
                    return [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            color: "primary",
                            loading: item.isDownloading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.fillAndDownloadPDF(item, index)
                            },
                          },
                        },
                        [_vm._v(" Fill & Download PDF ")]
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm.csvRows.length
        ? _c(
            VBtn,
            {
              staticClass: "my-3 mx-auto",
              attrs: { color: "primary", loading: _vm.isMergingAndDownloading },
              on: { click: _vm.fillAndDownloadAllPDFs },
            },
            [_vm._v(" Fill & Download All PDFs ")]
          )
        : _vm._e(),
      _c(
        VDialog,
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.warningDialog,
            callback: function ($$v) {
              _vm.warningDialog = $$v
            },
            expression: "warningDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, { staticClass: "headline" }, [
                _vm._v("Skipped Fields"),
              ]),
              _c(
                VCardText,
                _vm._l(_vm.skippedFields, function (message) {
                  return _c(
                    "div",
                    { key: message },
                    [
                      _c(VAlert, { attrs: { type: "error" } }, [
                        _vm._v(_vm._s(message)),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.warningDialog = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [_vm._v("Upload a PDF form with fillable fields.")]),
      _c("li", [
        _vm._v("Review the list of fields displayed from the PDF form."),
      ]),
      _c("li", [
        _vm._v(
          " Upload a CSV file with data to fill the PDF form. Ensure the CSV file has column headers matching the PDF form fields. "
        ),
      ]),
      _c("li", [_vm._v("Preview the CSV data in the datatable.")]),
      _c("li", [
        _vm._v("Download individual filled PDFs or all filled PDFs at once."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }